module.exports = __webpack_public_path__ + "static/shop-watermark-b819032b97f18a3d1888282907571cc1.svg";